// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue             from 'vue'
import lodash          from 'lodash'
import moment          from 'moment'
import adminApp        from './App'
import adminRouter     from './router/admin'
import notLoggedApp        from './Not_Logged_App'
import notLoggedRouter     from './router/not_logged'
import store     from './store'

Vue.config.productionTip = false

Vue.filter('twoDecimals', function (value) {
  return value ? value.toFixed(2) : '0.00';
});

Vue.filter('fromNow', function (value) {
  return moment(value).fromNow()
});

Vue.filter('formatDate', function (value) {
  return moment(value).format('DD/MM/YYYY HH:mm:ss')
});

Vue.filter('formatDateDay', function (value) {
  return moment(value).format('DD/MM/YYYY')
});

Vue.filter('formatDateHour', function (value) {
  return moment(value).format('HH:mm:ss')
});

/* eslint-disable no-new */
var token   = localStorage.getItem('token')

window._ = lodash
window.moment = moment

if (token) {
  new Vue({
    el: '#app',
    router: adminRouter,
    store,
    template: '<adminApp/>',
    components: { adminApp }
  })
} else {
  new Vue({
    el: '#app',
    router: notLoggedRouter,
    template: '<notLoggedApp/>',
    components: { notLoggedApp }
  })
}



// WEBPACK FOOTER //
// ./src/main.js